import { LineItem } from 'shared/types/cart';

const PROFESSIONAL_CERTIFICATE_KEYS = [
  'professional',
  'professional-certificate',
] as const;

export const hasBundleId = (lineItems: LineItem[]): boolean =>
  lineItems.some(({ bundleId }) => bundleId);

export const getBundleId = (lineItems: LineItem[]): string | undefined =>
  lineItems.find(({ bundleId }) => bundleId)?.bundleId;

/** True if any line item is a Professional Certificate (may not have bundleId). */
export const hasProfessionalCertificate = (lineItems: LineItem[]): boolean =>
  lineItems.some((item) => {
    const key = item.variant?.attributes?.programProductTypeKey?.toLowerCase();
    return key ? PROFESSIONAL_CERTIFICATE_KEYS.some((k) => k === key) : false;
  });
